import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Ticket } from 'projects/qcloud-models/console/ticket';
import { QcloudConsoleService } from '../../qcloud-console.service';
import { TicketReservation } from 'projects/qcloud-models/reservation/ticket-reservation';
import { ReservationService } from 'projects/qcloud-rest-client/src/lib/reservation.service';

@Component({
  selector: 'lib-call-ticket-manual-modal',
  templateUrl: './call-ticket-manual-modal.component.html',
  styleUrls: ['./call-ticket-manual-modal.component.css']
})
export class CallTicketManualModalComponent implements OnInit {
  @Output() hideInteractionModel = new EventEmitter<boolean>();
  tickets: Ticket[];

  ticketReservationTimes = new Map<number, string>();
  serveETicket: boolean;
  ticketReservations: TicketReservation[] = [];
  constructor(private consoleService: QcloudConsoleService, private reservationService: ReservationService) {
    this.consoleService.tickets.subscribe((val) => {
      this.tickets = val;
      this.getTodayTicketReservation();
    });
  }

  public getTodayTicketReservation() {
    var today = new Date();
    const startOfDay = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0);
    const endfDay = today;
    endfDay.setHours(24,0,0,0);
  }

  ngOnInit(): void {
    this.serveETicket = this.consoleService.user.hasPermissionToServeETickets;
  }

  jsonToNote(ticket: Ticket){
    return JSON.parse(ticket.metadataJson).Note;
  }

  jsonToNoteShort(ticket: Ticket){
    let text="";
    try{
      text = JSON.parse(ticket.metadataJson).Note;
      if(text.length > 20){
      text = text.substring(0, 20).concat('...');
      }
    }catch{}
      return text;
  }


  manualCallTicket(ticketId: number) {
    if (!this.serveETicket) {
      this.consoleService.callManualTicket(ticketId);
    } else {
      this.consoleService.callManualTicketWhileServedOther(ticketId);
    }
    this.hideInteractionModel.emit(true);
  }

  getCallingTime(ticket: Ticket) {
    console.log(ticket.callingDate);
    var dateTime = ticket.callingDate as unknown as string;
    if (!dateTime || !dateTime || dateTime === "0001-01-01T00:00:00+00:00") {
      return null;
    }
    const date = new Date(dateTime);
    if (isNaN(date.getTime())) {
      return null;
    }

    return date;
  }
}
